export default "__VITE_ASSET__9ed352bf__"